/**
 * Campo de texto longo — a irmã do `Campo`, que é de uma linha.
 *
 * Nota de receita, mensagem de suporte, texto de avaliação. O rótulo fica fora
 * e acima, e a altura mínima mostra três linhas: uma caixa de uma linha que
 * cresce esconde o que a pessoa já escreveu, e reler o que escreveu é metade
 * do trabalho de escrever.
 */
export function Area({
  rotulo,
  valor,
  onMudar,
  placeholder,
  linhas = 4,
  maximo,
  desabilitado,
  onEnviarAtalho,
}: {
  rotulo?: string;
  valor: string;
  onMudar: (v: string) => void;
  placeholder?: string;
  linhas?: number;
  /** Quando existe, mostra quanto falta — só depois de 80% usado. */
  maximo?: number;
  desabilitado?: boolean;
  /**
   * Ctrl+Enter (ou Cmd+Enter) envia. Enter sozinho NÃO envia: num campo de
   * texto longo, Enter é parágrafo, e mandar a mensagem no meio da frase é
   * exatamente o tipo de surpresa que esse público não perdoa.
   */
  onEnviarAtalho?: () => void;
}) {
  const perto = maximo != null && valor.length > maximo * 0.8;
  return (
    <div style={{ paddingLeft: "var(--gutter)", paddingRight: "var(--gutter)" }}>
      {rotulo && (
        <label
          className="mb-2 block font-semibold"
          style={{ fontSize: "var(--t-apoio)", color: "var(--tinta-apoio)" }}
        >
          {rotulo}
        </label>
      )}
      <textarea
        value={valor}
        rows={linhas}
        maxLength={maximo}
        onChange={(e) => onMudar(e.target.value)}
        onKeyDown={onEnviarAtalho && ((e) => {
          if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) onEnviarAtalho();
        })}
        disabled={desabilitado}
        placeholder={placeholder}
        className="w-full resize-y cartao px-4 py-3 outline-none placeholder:text-muted-foreground"
        style={{ fontSize: "var(--t-corpo)", lineHeight: 1.5 }}
      />
      {perto && (
        <p
          className="mt-1 text-right tabular-nums"
          style={{ fontSize: "var(--t-apoio)", color: "var(--tinta-apoio)" }}
        >
          {maximo! - valor.length}
        </p>
      )}
    </div>
  );
}
